module.exports = __webpack_public_path__ + "img/love.8e033f8b.jpg";